import { render, staticRenderFns } from "./autocomplete--researcher.vue?vue&type=template&id=0c6ee8fa&"
import script from "./autocomplete--researcher.vue?vue&type=script&lang=js&"
export * from "./autocomplete--researcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports